// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nzaxUc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-5);
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
}

.UlMXU2 {
  margin: 0;
  max-width: 48rem;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: 131%;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: left;
}

.ctr6I9 {
  color: var(--brand-tr-orange);
}

.j3GM8m {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 45.8125rem;
  height: 0.625rem;
  align-self: flex-start;
}

.zBQS3x {
  flex: 1 1 auto;
  min-width: 0;
  height: 2px;
  align-self: center;
  border-radius: 1px;
  background: var(--brand-tr-orange);
}

.bHuxpC {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: var(--brand-tr-orange);
  flex-shrink: 0;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesIntegrationBanner/InsideSalesIntegrationBanner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-5);\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.title {\n  margin: 0;\n  max-width: 48rem;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 131%;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: left;\n}\n\n.highlight {\n  color: var(--brand-tr-orange);\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  max-width: 45.8125rem;\n  height: 0.625rem;\n  align-self: flex-start;\n}\n\n.dividerLine {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 2px;\n  align-self: center;\n  border-radius: 1px;\n  background: var(--brand-tr-orange);\n}\n\n.dividerDot {\n  width: 0.625rem;\n  height: 0.625rem;\n  border-radius: 50%;\n  background: var(--brand-tr-orange);\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `nzaxUc`,
	"title": `UlMXU2`,
	"highlight": `ctr6I9`,
	"divider": `j3GM8m`,
	"dividerLine": `zBQS3x`,
	"dividerDot": `bHuxpC`
};
module.exports = ___CSS_LOADER_EXPORT___;
